import store_rendez_vous from '@/store/mods/clinique/rendez_vous'
import { message_erreur } from '@/utils/rendez-vous'

// RDV-005 : indicateurs du mois des rendez-vous (Accueil, Caisse) — volume et états, taux d'absence, ponctualité à
// l'arrivée en caisse, part des rendez-vous rappelés et absence selon le rappel. Calculés par la Clinique dans le fuseau
// de l'établissement ; le poste ne fait qu'afficher.
export const MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']

const pourcentage = valeur => (valeur === null || valeur === undefined) ? '—' : valeur + ' %'

// Ton d'une carte : « bon », « attention », « alerte » ou « neutre » (pas de mesure)
export function ton(valeur, bon, attention, croissant) {
    if (valeur === null || valeur === undefined) return 'neutre'
    if (croissant) return valeur >= bon ? 'bon' : (valeur >= attention ? 'attention' : 'alerte')
    return valeur <= bon ? 'bon' : (valeur <= attention ? 'attention' : 'alerte')
}

export default {
    name: 'indicateurs-rendez-vous',
    props: {
        mois: { type: String, default: '' },
        medecin_id: { type: [String, Number], default: '' },
        toggler: { type: Number, default: 0 }
    },
    data() {
        return { indicateurs: null, is_loading: false, erreur: '', sequence: 0, detruit: false }
    },

    watch: {
        mois() { this.charger() },
        medecin_id() { this.charger() },
        toggler() { this.charger() }
    },

    computed: {
        libelle_mois() {
            const mois = this.indicateurs && this.indicateurs.mois ? this.indicateurs.mois : this.mois
            if (!/^\d{4}-\d{2}$/.test(mois || '')) return 'mois en cours'
            return MOIS[Number(mois.substr(5, 2)) - 1] + ' ' + mois.substr(0, 4)
        },

        vide() {
            return !!this.indicateurs && Number(this.indicateurs.total) === 0
        },

        cartes() {
            const i = this.indicateurs
            if (!i || !i.counts) return []
            const ponctualite = i.ponctualite || {}
            const rappel = i.rappel || {}
            const counts = i.counts
            const comparaison = (rappel.absence_rappeles !== null && rappel.absence_rappeles !== undefined) || (rappel.absence_non_rappeles !== null && rappel.absence_non_rappeles !== undefined)
            return [
                { id: 'total', titre: 'Rendez-vous du mois', valeur: String(i.total), ton: 'neutre',
                    detail: counts.honore + ' honoré(s) · ' + counts.absent + ' absent(s) · ' + counts.annule + ' annulé(s) · ' + counts.planifie + ' planifié(s)' },
                { id: 'absence', titre: 'Taux d\'absence', valeur: pourcentage(i.taux_absence), ton: ton(i.taux_absence, 10, 20, false),
                    detail: 'Absents parmi les rendez-vous renseignés' + (i.non_renseignes ? ' · ' + i.non_renseignes + ' passé(s) non renseigné(s)' : '') },
                { id: 'ponctualite', titre: 'Arrivés à l\'heure', valeur: pourcentage(ponctualite.a_l_heure), ton: ton(ponctualite.a_l_heure, 80, 60, true),
                    detail: ponctualite.mesures ? ('Arrivée en caisse au plus ' + ponctualite.tolerance_minutes + ' min après l\'heure · retard moyen ' + ponctualite.retard_moyen_minutes + ' min · ' + ponctualite.mesures + ' mesure(s)')
                        : 'Aucune arrivée mesurée en caisse ce mois-ci' },
                { id: 'rappel', titre: 'Patients rappelés', valeur: pourcentage(rappel.part), ton: ton(rappel.part, 80, 50, true),
                    detail: comparaison ? ('Absence : ' + pourcentage(rappel.absence_rappeles) + ' si rappelé, ' + pourcentage(rappel.absence_non_rappeles) + ' sinon')
                        : 'Pas encore de rendez-vous renseignés pour comparer' }
            ]
        }
    },

    mounted() {
        this.charger()
    },

    beforeDestroy() {
        this.detruit = true
        this.sequence++
    },

    methods: {
        charger() {
            if (this.detruit) return Promise.resolve()
            const sequence = ++this.sequence
            const data = {}
            if (/^\d{4}-\d{2}$/.test(this.mois || '')) data.mois = this.mois
            if (this.medecin_id) data.medecin_id = Number(this.medecin_id)
            this.is_loading = true
            this.erreur = ''
            return store_rendez_vous.getIndicateurs(data).then((response) => {
                if (this.detruit || sequence !== this.sequence) return
                if (!response || response.success !== true || !response.data || !response.data.counts) throw new Error('Réponse invalide')
                this.indicateurs = response.data
                this.is_loading = false
            }).catch((error) => {
                if (this.detruit || sequence !== this.sequence) return
                this.indicateurs = null
                this.is_loading = false
                this.erreur = message_erreur(error, 'Indicateurs indisponibles pour le moment. Réessayez avec Actualiser.')
            })
        }
    }
}
